import styled, { css, keyframes } from 'styled-components'

import { color, media } from '../../../../themes'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

const slideInFromBottom = keyframes`
  from {
    transform: translate(-50%, 100%);
  }
  to {
    transform: translate(-50%, 0);
  }
`

const slideOutToBottom = keyframes`
  from {
    transform: translate(-50%, 0);
  }
  to {
    transform: translate(-50%, 100%);
  }
`

interface InnerProps {
  open?: boolean
  position?: 'center'
  expandOnSmallDevices?: boolean
  baseWidth?: number
  animationType?: 'fade' | 'slide-from-bottom'
}

export const Inner = styled.div<InnerProps>`
  /* animation: ${({ open }) => (open ? fadeIn : fadeOut)} 0.3s ease; */
  animation: ${({ open, animationType = 'fade' }) =>
      open
        ? animationType === 'slide-from-bottom'
          ? slideInFromBottom
          : fadeIn
        : animationType === 'slide-from-bottom'
        ? slideOutToBottom
        : fadeOut}
    0.3s ease;
  position: absolute;
  z-index: 150;
  background-color: ${color('white')};
  box-shadow: 0 0 8px 0 rgb(0 0 0 / 12%), 0 8px 8px 0 rgb(0 0 0 / 24%);
  display: flex;
  flex-direction: column;
  height: auto;
  max-width: 100%;
  max-height: 70vh;
  width: ${({ baseWidth }) => (baseWidth ? `${baseWidth}px` : 'auto')};

  ${({ expandOnSmallDevices, baseWidth }) =>
    expandOnSmallDevices &&
    css`
      min-width: 100vw;
      height: 100vh;
      max-height: 100vh;

      @supports (-webkit-touch-callout: none) {
        height: -webkit-fill-available;
      }

      ${media.pc} {
        width: ${baseWidth ? `${baseWidth}px` : 'auto'};
        min-width: auto;
        height: auto;
        max-height: 70vh;
      }
    `}

  ${({ position = 'center' }) =>
    position === 'center' &&
    css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}

  ${({ animationType }) =>
    animationType === 'slide-from-bottom' &&
    css`
      top: auto;
      bottom: 0;
      transform: translate(-50%, 0);
    `}
`

export const Content = styled.div`
  flex-grow: 1;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative;
  display: flex;
  flex-direction: column;

  ::-webkit-scrollbar {
    display: none;
  }
`
